// src/components/layout/Footer.jsx
import { Link } from 'react-router-dom'; // ← Use React Router Links for internal pages

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-slate-300 ">
      {/* Main footer content */}
      <div className="container mx-auto px-6 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8 xl:gap-12">
          {/* Column 1 - Brand & Description */}
          <div className="flex flex-col">
            <h3 className="text-3xl md:text-3.5xl font-bold text-white tracking-tight mb-5">
              DR. SRIDHAR
            </h3>
            <p className="text-slate-400 leading-relaxed mb-6 max-w-md">
              Sridhar International Dental Hospital – Restoring confident smiles since 1995. 
              Advanced technology, compassionate experts, and personalized care for every generation.
            </p>

            {/* Social Icons with flex */}
            <div className="flex items-center gap-5">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-blue-400 transition-colors duration-300 text-xl"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-pink-400 transition-colors duration-300 text-xl"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-blue-300 transition-colors duration-300 text-xl"
                aria-label="Twitter / X"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-blue-500 transition-colors duration-300 text-xl"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="flex flex-col">
            <h4 className="text-lg font-semibold text-white mb-5 pb-2 border-b border-blue-700/50 inline-block">
              Quick Links
            </h4>
            <ul className="space-y-3 flex flex-col">
              <li>
                <Link to="/about" className="hover:text-blue-400 transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-blue-400 transition-colors duration-200">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-blue-400 transition-colors duration-200">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-blue-400 transition-colors duration-200">
                  Our Blog
                </Link>
              </li>
              <li>
              <Link to="/gallery" className="hover:text-blue-400 transition-colors duration-200">
  Gallery
</Link>
</li>
              <li>
                <Link to="/contact" className="hover:text-blue-400 transition-colors duration-200">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Support & Policies */}
          <div className="flex flex-col">
            <h4 className="text-lg font-semibold text-white mb-5 pb-2 border-b border-blue-700/50 inline-block">
              Support
            </h4>
            <ul className="space-y-3 flex flex-col">
              <li>
                <Link to="/privacy-policy" className="hover:text-blue-400 transition-colors duration-200">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="hover:text-blue-400 transition-colors duration-200">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-blue-400 transition-colors duration-200">
                  Frequently Asked Questions
                </Link>
              </li>
              <li>
                <a href="tel:+918121222666" className="hover:text-blue-400 transition-colors duration-200">
                  Need Help?
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Contact + Newsletter */}
          <div className="flex flex-col">
            <h4 className="text-lg font-semibold text-white mb-5 pb-2 border-b border-blue-700/50 inline-block">
              Get in Touch
            </h4>

            <div className="space-y-5 mb-8">
              <div className="flex items-start gap-3">
                <span className="text-blue-400 text-2xl flex-shrink-0">📍</span>
                <p className="leading-relaxed">
                  Vijayawada • Hyderabad<br />
                  <span className="text-slate-500 text-sm">
                    (Main branches in Andhra Pradesh & Telangana)
                  </span>
                </p>
              </div>

              <div className="flex items-center gap-3">
                <span className="text-blue-400 text-2xl flex-shrink-0">📞</span>
                <div>
                  <a href="tel:+919490948081" className="hover:text-blue-400 transition">
                    +91 9490 948 081
                  </a>
                  <span className="mx-2">|</span>
                  <a href="tel:+919542027700" className="hover:text-blue-400 transition">
                    +91 95420 27700
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <span className="text-blue-400 text-2xl flex-shrink-0">✉️</span>
                <a
                  href="mailto:info@sridhardental.com"
                  className="hover:text-blue-400 transition"
                >
                  info@sridhardental.com
                </a>
              </div>
            </div>

            {/* Newsletter */}
            <div>
              <p className="text-sm mb-4 text-slate-400">
                Subscribe for dental tips & offers
              </p>
              <form className="flex flex-wrap sm:flex-nowrap gap-2">
                <input
                  type="email"
                  placeholder="Your email address"
                  required
                  className="flex-1 min-w-0 px-4 py-3 rounded-lg bg-slate-800 border border-slate-700 text-white 
                           placeholder-slate-500 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
                <button
                  type="submit"
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium 
                           transition-colors duration-300 shadow-sm hover:shadow-md"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="bg-black/60 py-6 text-center text-sm border-t border-slate-800">
        <div className="container mx-auto px-6">
          <p className="text-slate-400">
            © {currentYear} DR. SRIDHAR International Dental Hospital – All rights reserved
          </p>
          <p className="mt-2 text-slate-500">
            Specialized Dental Care | Designed & Developed by Oakya IT Services Pvt Ltd
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;